import CouponsDashboard from "./CouponsDashboard";

export default CouponsDashboard;
